/* ============================================================
   STICKY ADD TO CART — Peach Active
   - Shows the bar once the main add-to-cart form scrolls out
     of view (IntersectionObserver).
   - Desktop: Color/Size dropdowns -> resolves the variant
     -> adds via /cart/add.js -> opens the cart drawer.
   - Mobile: smooth-scrolls back to the main product form.
   ============================================================ */

(function () {
  var root = document.querySelector('[data-sticky-atc]');
  if (!root) return;

  var variantsEl = document.querySelector('[data-sticky-atc-variants]');
  if (!variantsEl) return;

  var variants;
  try {
    variants = JSON.parse(variantsEl.textContent);
  } catch (e) {
    return;
  }

  var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
  var addedText = root.getAttribute('data-added-text') || 'Added ✓';
  var soldoutText = root.getAttribute('data-soldout-text') || 'Sold Out';
  var unavailableText = root.getAttribute('data-unavailable-text') || 'Unavailable';

  var addBtn = root.querySelector('[data-sticky-atc-add]');
  var addBtnText = root.querySelector('[data-sticky-atc-add-text]');
  var scrollBtn = root.querySelector('[data-sticky-atc-scroll]');
  var priceEl = root.querySelector('[data-sticky-atc-price]');
  var defaultBtnText = addBtnText ? addBtnText.textContent : 'Add to Cart';

  /* ---------- Find the theme's main add-to-cart button ----------
     Themes can have several /cart/add forms in the DOM (quickbuy,
     hidden mobile/desktop duplicates), so target the first VISIBLE
     buy button outside this bar, and fall back to the form. */
  function isVisible(el) {
    return !!(
      el &&
      el.offsetParent !== null &&
      el.getBoundingClientRect().height > 0
    );
  }

  var mainAtcBtn = null;
  var mainForm = null;
  (function () {
    var buttons = document.querySelectorAll(
      'form[action*="/cart/add"] [name="add"], form[action*="/cart/add"] button[type="submit"]'
    );
    for (var i = 0; i < buttons.length; i++) {
      if (!root.contains(buttons[i]) && isVisible(buttons[i])) {
        mainAtcBtn = buttons[i];
        break;
      }
    }
    if (mainAtcBtn && mainAtcBtn.closest) {
      mainForm = mainAtcBtn.closest('form');
    }
    if (!mainForm) {
      mainForm =
        document.querySelector('.product-detail form[action*="/cart/add"]') ||
        document.querySelector('form[action*="/cart/add"]');
    }
  })();

  /* ---------- Selected option state (dropdowns) ---------- */
  var selects = Array.prototype.slice.call(
    root.querySelectorAll('[data-sticky-atc-select]')
  );
  var selected = selects.map(function (sel) {
    return sel.value;
  });

  /* Remember each option's original label so we can toggle
     the " — Sold out" suffix cleanly */
  selects.forEach(function (sel) {
    Array.prototype.forEach.call(sel.options, function (opt) {
      opt.setAttribute('data-label', opt.textContent);
    });
  });

  function findVariant() {
    return variants.find(function (v) {
      return selected.every(function (val, i) {
        return v['option' + (i + 1)] === val;
      });
    });
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    var amount = (cents / 100).toFixed(2);
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','));
  }

  function updateUI() {
    var variant = findVariant();

    /* Mark sold-out choices (given the other selections) */
    selects.forEach(function (sel, i) {
      Array.prototype.forEach.call(sel.options, function (opt) {
        var match = variants.find(function (v) {
          return selected.every(function (val, j) {
            var need = j === i ? opt.value : val;
            return v['option' + (j + 1)] === need;
          });
        });
        var base = opt.getAttribute('data-label') || opt.textContent;
        opt.textContent =
          !match || !match.available ? base + ' — Sold out' : base;
      });
    });

    if (!addBtn) return;

    if (!variant) {
      addBtn.disabled = true;
      if (addBtnText) addBtnText.textContent = unavailableText;
      return;
    }

    if (!variant.available) {
      addBtn.disabled = true;
      if (addBtnText) addBtnText.textContent = soldoutText;
    } else {
      addBtn.disabled = false;
      if (addBtnText) addBtnText.textContent = defaultBtnText;
    }

    if (priceEl) {
      var html = '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html += '<s class="sticky-atc__price-compare">' + formatMoney(variant.compare_at_price) + '</s> ';
      }
      html += formatMoney(variant.price);
      priceEl.innerHTML = html;
    }
  }

  /* ---------- Dropdown changes ---------- */
  selects.forEach(function (sel, i) {
    sel.addEventListener('change', function () {
      selected[i] = sel.value;
      updateUI();
    });
  });

  /* ---------- Open the cart drawer after adding ----------
     HOOK POINT: if the Peach cart drawer exposes its own open /
     refresh function or event, call it here first. */
  function openCartDrawer() {
    document.dispatchEvent(new CustomEvent('sticky-atc:added'));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));

    var cartToggle = document.querySelector(
      '.cart-link, a[href="/cart"], [data-cart-toggle], .header__cart-toggle'
    );
    if (cartToggle) {
      cartToggle.click();
    }
  }

  /* ---------- AJAX add to cart (desktop) ---------- */
  if (addBtn) {
    addBtn.addEventListener('click', function () {
      var variant = findVariant();
      if (!variant || !variant.available) return;

      addBtn.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: variant.id, quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          addBtn.classList.remove('is-loading');
          if (addBtnText) addBtnText.textContent = addedText;
          setTimeout(function () {
            if (addBtnText) addBtnText.textContent = defaultBtnText;
          }, 2000);
          openCartDrawer();
        })
        .catch(function () {
          addBtn.classList.remove('is-loading');
          if (addBtnText) addBtnText.textContent = unavailableText;
          setTimeout(function () {
            if (addBtnText) addBtnText.textContent = defaultBtnText;
            updateUI();
          }, 2000);
        });
    });
  }

  /* ---------- Mobile: scroll back, centering the main ATC button ---------- */
  if (scrollBtn) {
    scrollBtn.addEventListener('click', function () {
      var target = mainAtcBtn || mainForm || document.querySelector('.product-detail');
      if (!target) return;
      var rect = target.getBoundingClientRect();
      var top = rect.top + window.pageYOffset - (window.innerHeight / 2) + (rect.height / 2);
      window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    });
  }

  /* ---------- Show / hide the bar ----------
     Watch the buy button itself: only show once the button's
     BOTTOM edge has scrolled above the top of the viewport. */
  var observeTarget = mainAtcBtn || mainForm || document.querySelector('.product-detail');
  if (!observeTarget) {
    root.classList.add('is-visible');
    root.setAttribute('aria-hidden', 'false');
  } else if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var pastButton =
            !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          root.classList.toggle('is-visible', pastButton);
          root.setAttribute('aria-hidden', pastButton ? 'false' : 'true');
        });
      },
      { threshold: 0 }
    );
    observer.observe(observeTarget);
  } else {
    root.classList.add('is-visible');
    root.setAttribute('aria-hidden', 'false');
  }

  updateUI();
})();
